import { DsLibMainMenuLinkInterface } from '../interfaces/ds-lib-main-menu-link.interface';

export class DsLibMainMenuLink {
  /**
   *
   */
  title?: string;

  /**
   *
   */
  url: string;

  /**
   *
   */
  icon?: string;

  /**
   *
   */
  disabled?: boolean;

  /** Optional: the link will only appear if the user has the corresponding right(s) */
  rights?: number[];

  /** Optional: the link will use external link if it's true, use routind else */
  external?: boolean;

  /**
   * Creates an instance of DsLibMainMenuLink.
   *
   * @param json Given link interface
   */
  constructor(json: DsLibMainMenuLinkInterface) {
    this.title = json.title;
    this.url = json.url;
    this.icon = json.icon;
    this.disabled = json.disabled;
    this.rights = json.rights;
    this.external = json.external;
  }
}
